"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getGradeRemovedEvent_1 = require("../helpers/getEvent/getGradeRemovedEvent");
const getInteractionKey_1 = require("../helpers/getInteraction/getInteractionKey");
const getState_1 = require("../helpers/getState");
const getStateInteraction_1 = require("../helpers/getStateInteraction");
const entity_1 = require("../type/entity");
function applyRemoveTeacherGradeCommand(command, user, content, states, stateInteractions) {
    const { timeStamp, assignmentCardId } = command;
    const { userId } = user;
    const events = [];
    const updatedModel = immer_1.produce({
        stateInteractions,
        states
    }, InputModel => {
        const { stateInteractions: draftStateInteractions, states: draftStates } = InputModel;
        const assignmentCardContent = getContent_1.getContentByContentId(content, assignmentCardId);
        if (assignmentCardContent) {
            assignmentCardContent.children.forEach((cardQuestionContent) => {
                const cardQuestionState = getState_1.getStateByContentIdUserId(draftStates, cardQuestionContent._id, userId);
                // deleting stateInteractions
                const teacherId = cardQuestionState.submissions[0].gradedBy;
                const interactionKeyForLearner = getInteractionKey_1.getInteractionKeyForLearner(cardQuestionContent._id, entity_1.InteractionType.Grade, cardQuestionState.submissions[0]._id, teacherId);
                const gradeInteraction = getStateInteraction_1.getStateInteractionByInteractionKeyForLearner(draftStateInteractions, interactionKeyForLearner);
                if (!gradeInteraction) {
                    throw new Error('no gradeInteraction found for the current gradedBy in submission available to update');
                }
                gradeInteraction.deleted = true;
                // removing grade from state
                cardQuestionState.rawScore = cardQuestionState.submissions[0].rawScore = 0;
                cardQuestionState.submissions[0].gradedBy = null;
                cardQuestionState.submissions[0].gradedOn = null;
                cardQuestionState.updatedAt = timeStamp;
                const gradeRemovedEvent = getGradeRemovedEvent_1.getGradeRemovedEvent(command, user, content._id, getContentType_1.getContentType(cardQuestionContent), cardQuestionContent._id, cardQuestionState.submissions[0]._id);
                events.push(gradeRemovedEvent);
            });
        }
    });
    return Object.assign({ events, enrolments: [] }, updatedModel);
}
exports.applyRemoveTeacherGradeCommand = applyRemoveTeacherGradeCommand;
//# sourceMappingURL=applyRemoveTeacherGradeCommand.js.map